import {call, put} from 'redux-saga/effects'
import axios from 'axios'
import axiosCustom from './axiosCustom'
import {alertActions} from '../actions'

// Asynchronnous function that performs the actual data fetch
async function getData(url, token) {
    let resp
    const source = axios.CancelToken.source()

    try {
        axiosCustom.defaults.headers.common['Authorization'] = 'Bearer ' + token

        let data = await axiosCustom.get(url, {
            cancelToken: source.token,
            timeout: process.env.REACT_APP_REQUEST_TIMEOUT,
            validateStatus: function(status) {
                return status < 500 // Resolve only if the status code is less than 500
            },
        })

        if (data.status === 200 || data.status === 404 || data.status === 401) {
            resp = data
        } else {
            throw new Error(
                'Code(' +
                    data.status +
                    ') Something went wrong fetching ' +
                    url +
                    ' data...'
            )
        }
    } catch (e) {
        const errorMessage = (e.title ? e.title : 'Error') + '. ' + e.message
        resp = {err: errorMessage}
    }

    return resp
}

// Function generator to handle all fetch request. Uses Yield command waits till the step is completed
// Takes action objects to handle
export function* getDataAPI(
    url,
    token,
    successAction,
    failureAction,
    failureAlert
) {
    let resp

    try {
        const axiosresp = yield call(getData, url, token)
        const {data, status} = axiosresp

        resp = data

        if (status === 200) {
            yield put({type: successAction, data})
        }
    } catch (e) {
        yield put({type: failureAction, message: e})
        yield put({type: failureAlert, message: e})
    }

    return resp
}

// Asynchronnous function that performs the actual data post
async function lookupData(url, token, lookupParams) {
    let resp
    const source = axios.CancelToken.source()
    const {firstName: firstname, lastName: lastname, monthDay} = lookupParams

    try {
        const tempwbirthdate =
            monthDay && monthDay.trim() ? monthDay.split('/') : ''
        let monthOfBirth = tempwbirthdate[0] * 1 - 1
        let dayOfBirth = tempwbirthdate[1]
        let yearOfBirth = tempwbirthdate[2]

        axiosCustom.defaults.headers.common['Authorization'] = 'Bearer ' + token
        let birthDate =
            tempwbirthdate.length > 0
                ? new Date(yearOfBirth, monthOfBirth, dayOfBirth)
                : null

        let getURL =
            url +
            '?firstName=' +
            firstname.trim() +
            '&lastName=' +
            lastname.trim() +
            (tempwbirthdate.length > 0
                ? '&birthDate=' + birthDate.toISOString()
                : '')

        let data = await axiosCustom.get(getURL, {
            cancelToken: source.token,
            timeout: process.env.REACT_APP_REQUEST_TIMEOUT,
        })
        if (data.status === 200) {
            resp = data
        } else {
            throw new Error('Something went wrong fetching events data...')
        }
    } catch (e) {
        const errorMessage = e.title + '. ' + e.message
        resp = {err: errorMessage}
    }

    return resp
}

// Function generator to handle all post request. Uses Yield command waits till the step is completed
// Takes action objects to handle
export function* lookupDataAPI(
    url,
    token,
    lookupParams,
    successAction,
    failureAction,
    failureAlert
) {
    let resp

    try {
        const {data, err} = yield call(lookupData, url, token, lookupParams)
        if (data) {
            resp = data

            yield put({type: successAction, data})
        } else {
            yield put({type: failureAction, message: err})
            yield put({type: failureAlert, message: err})
        }
    } catch (e) {
        yield put({type: failureAction, message: e})
        yield put({type: failureAlert, message: e})
    }

    return resp
}

// Asynchronnous function that performs the actual post method for swipes
async function postSwipe(url, token, swipeId) {
    let resp
    const source = axios.CancelToken.source()

    axiosCustom.defaults.headers.common['Authorization'] = 'Bearer ' + token

    try {
        let data = await axiosCustom.post(
            url,
            {swipeId},
            {
                cancelToken: source.token,
                timeout: process.env.REACT_APP_REQUEST_TIMEOUT,
                validateStatus: function(status) {
                    return status < 500 // Resolve only if the status code is less than 500
                },
            }
        )
        if (data) {
            resp = data
        } else {
            throw new Error('Something went wrong putting swipe data...')
        }
    } catch (e) {
        const errorMessage = e.title + '. ' + e.message
        resp = {err: errorMessage}
    }

    return resp
}

// Function generator to handle all swipe request. Uses Yield command waits till the step is completed
// Takes action objects to handle
export function* swipeDataAPI(
    url,
    token,
    swipeId,
    successAction,
    failureAction,
    failureAlert
) {
    try {
        const axiosresp = yield call(postSwipe, url, token, swipeId)
        const {data, status} = axiosresp

        if (status === 201) {
            yield put({type: successAction, data})
            yield put(
                alertActions.success(
                    'Swipe accepted. ' +
                        data.firstName +
                        ' ' +
                        data.lastName +
                        ' swipe was recorded.'
                )
            )
        } else {
            const errorMessage = 'Swipe denied. ' + data.message
            yield put({type: failureAction, message: errorMessage})
            yield put({type: failureAlert, message: errorMessage})
        }
    } catch (e) {
        yield put({type: failureAction, message: e})
        yield put({type: failureAlert, message: e})
    }
}

// Asynchronnous function that performs the actual post method for batch swipes
async function postBatchSwipe(url, token, startDate, swipeIdArray) {
    let resp
    const CancelToken = axios.CancelToken
    const source = CancelToken.source()
    const swipeIds = [...swipeIdArray]
    axiosCustom.defaults.headers.common['Authorization'] = 'Bearer ' + token

    const recordSwipes = url.includes('/swipe-management/batch/swipe/')
    try {
        let data = await axiosCustom.post(
            url,
            recordSwipes
                ? {selectedStartDate: startDate, emplids: swipeIds}
                : {swipeIds},
            {
                cancelToken: source.token,
                timeout: process.env.REACT_APP_REQUEST_TIMEOUT,
                validateStatus: function(status) {
                    return status < 500 // Resolve only if the status code is less than 500
                },
            }
        )
        if (data) {
            resp = data
        } else {
            throw new Error('Something went wrong processing swipe data...')
        }
    } catch (e) {
        const errorMessage = e.title + '. ' + e.message
        resp = {err: errorMessage}
    }

    return resp
}

// Function generator to handle all batch swipe request. Uses Yield command waits till the step is completed
// Takes action objects to handle
export function* batchswipeDataAPI(
    url,
    token,
    startDate,
    swipeIdArray,
    failureAction,
    failureAlert
) {
    try {
        const axiosresp = yield call(
            postBatchSwipe,
            url,
            token,
            startDate,
            swipeIdArray
        )
        const {data, status, err} = axiosresp
        if (status === 201 || status === 200) {
            return data
        } else {
            const errorMessage = err
                ? err
                : 'Batch Upload File Error. ' + data.message
            yield put({type: failureAction, message: errorMessage})
            yield put({type: failureAlert, message: errorMessage})
        }
    } catch (e) {
        yield put({type: failureAction, message: e})
        yield put({type: failureAlert, message: e})
    }
}

// Asynchronnous function that performs the actual data patch
async function patchData(url, token, body) {
    let resp
    const source = axios.CancelToken.source()

    try {
        axiosCustom.defaults.headers.common['Authorization'] = 'Bearer ' + token

        let data = await axiosCustom.patch(url, body, {
            cancelToken: source.token,
            timeout: process.env.REACT_APP_REQUEST_TIMEOUT,
        })

        if (data.status === 200) {
            resp = data
        } else {
            throw new Error('Something went wrong patching events data...')
        }
    } catch (e) {
        const errorMessage = e.title + '. ' + e.message
        resp = {err: errorMessage}
    }

    return resp
}

// Function generator to handle all patch request. Uses Yield command waits till the step is completed
// Takes action objects to handle patch operations
export function* patchDataAPI(
    url,
    token,
    body,
    successAction,
    failureAction,
    failureAlert
) {
    let resp

    try {
        const {data, err} = yield call(patchData, url, token, body)

        if (data) {
            resp = data
            yield put({type: successAction, data})
        } else {
            yield put({type: failureAction, message: err})
            yield put({type: failureAlert, message: err})
        }
    } catch (e) {
        yield put({type: failureAction, message: e})
        yield put({type: failureAlert, message: e})
    }

    return resp
}

// Asynchronnous function that performs the actual post method for swipes
async function putData(url, token, body) {
    let resp
    const source = axios.CancelToken.source()

    axiosCustom.defaults.headers.common['Authorization'] = 'Bearer ' + token

    try {
        let data = await axiosCustom.put(url, body, {
            cancelToken: source.token,
            timeout: process.env.REACT_APP_REQUEST_TIMEOUT,
        })
        if (data.status === 200) {
            resp = data
        } else {
            throw new Error('Something went wrong putting data...')
        }
    } catch (e) {
        const errorMessage = e.title + '. ' + e.message
        resp = {err: errorMessage}
    }

    return resp
}

// Function generator to handle all put requests. Uses Yield command waits till the step is completed
// Takes action objects to handle
export function* putDataAPI(
    url,
    token,
    body,
    successAction,
    failureAction,
    failureAlert
) {
    let resp

    try {
        const axiosresp = yield call(putData, url, token, body)
        const {data} = axiosresp

        if (data) {
            resp = data
            yield put({type: successAction, data})
        }
    } catch (err) {
        yield put({type: failureAction, message: err})
        yield put({type: failureAlert, message: err})
    }

    return resp
}

// Asynchronnous function that performs the actual post method for swipes
async function postData(url, token, body) {
    let resp
    const source = axios.CancelToken.source()

    axiosCustom.defaults.headers.common['Authorization'] = 'Bearer ' + token

    try {
        let data = await axiosCustom.post(url, body, {
            cancelToken: source.token,
            timeout: process.env.REACT_APP_REQUEST_TIMEOUT,
        })
        if (data.status === 200 || data.status === 201) {
            resp = data
        } else {
            throw new Error('Something went wrong posting data...')
        }
    } catch (e) {
        const errorMessage = e.title + '. ' + e.message
        resp = {err: errorMessage}
    }

    return resp
}

// Function generator to handle all POST requests. Uses Yield command waits till the step is completed
// Takes action objects to handle
export function* postDataAPI(
    url,
    token,
    body,
    successAction,
    failureAction,
    failureAlert
) {
    try {
        const {data, err} = yield call(postData, url, token, body)

        if (data) {
            yield put({type: successAction, data})
            return data
        } else {
            yield put({type: failureAction, message: err})
            yield put({type: failureAlert, message: err})
        }
    } catch (e) {
        yield put({type: failureAction, message: e})
        yield put({type: failureAlert, message: e})
    }
}

// Asynchronnous function that performs the actual delete method for swipes
async function deleteData(url, token) {
    let resp
    const source = axios.CancelToken.source()

    axiosCustom.defaults.headers.common['Authorization'] = 'Bearer ' + token

    try {
        let data = await axiosCustom.delete(url, {
            cancelToken: source.token,
            timeout: process.env.REACT_APP_REQUEST_TIMEOUT,
            validateStatus: function(status) {
                return status < 500 // Resolve only if the status code is less than 500
            },
        })

        if (data.status === 204 || data.status === 409) {
            resp = data
        } else {
            throw new Error(
                'Code(' + data.status + ') Something went wrong deleting ' + url
            )
        }
    } catch (e) {
        const errorMessage = e.title + '. ' + e.message
        resp = {err: errorMessage}
    }

    return resp
}

// Function generator to handle all POST requests. Uses Yield command waits till the step is completed
// Takes action objects to handle
export function* deleteDataAPI(
    url,
    token,
    successAction,
    failureAction,
    failureAlert
) {
    try {
        const axiosresp = yield call(deleteData, url, token)
        const {data, status, err} = axiosresp

        if (status === 204) {
            yield put({type: successAction})
            return status
        } else {
            let errormsg
            if (data) {
                errormsg = 'Error(code ' + data.statusCode + ') ' + data.message
            } else {
                errormsg = err
            }
            yield put({type: failureAction, message: errormsg})
            yield put({type: failureAlert, message: errormsg})
        }
    } catch (e) {
        yield put({type: failureAction, message: e})
        yield put({type: failureAlert, message: e})
    }
}
